<template>
    <div
        class="h-full w-full"
        style="background: #F8F8F8"
    >
        <div class="w-full max-w-7xl mx-auto h-full pb-20">
            <div class="mx-20 2xl:mx-0">
                <div class="flex mb-10 pt-10">
                    <h1 class="text-3xl">
                        Aktiviteter
                    </h1>
                </div>
                <div class="w-full h-full">
                    <div class="w-full h-full flex flex-col justify-center items-center">
                        <svg width="39" height="30" viewBox="0 0 39 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.5 17H25.5H13.5ZM19.5 11V23V11ZM1.5 25V5C1.5 3.93913 1.92143 2.92172 2.67157 2.17157C3.42172 1.42143 4.43913 1 5.5 1H17.5L21.5 5H33.5C34.5609 5 35.5783 5.42143 36.3284 6.17157C37.0786 6.92172 37.5 7.93913 37.5 9V25C37.5 26.0609 37.0786 27.0783 36.3284 27.8284C35.5783 28.5786 34.5609 29 33.5 29H5.5C4.43913 29 3.42172 28.5786 2.67157 27.8284C1.92143 27.0783 1.5 26.0609 1.5 25Z" stroke="#8E87C7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <p class="mt-6 font-semibold">Add activity</p>
                        <p class="text-gray-600">Get Started by choosing an activity</p>
                        <button
                            @click="showModal = true"
                            type="button"
                            class="mt-10 bg-primary-dark text-white rounded-md py-2 px-4 border border-font hover:bg-primary"
                        >
                            + Choose from list
                        </button>
                    </div>
                    <div class="w-full rounded-lg grid grid-cols-2 gap-x-4 gap-y-4">

                    </div>
                </div>
            </div>
        </div>
    </div>

    <ActivityModal
        :show="showModal"
        @cancel="cancel"
        :size="`max-w-6xl`"
        :localDB="localDB"
        :otherDB="otherDB"
        @activity="addActivity"
    />
</template>

<script setup>
import {ref} from "vue";
import ActivityModal from '../Modal/Proposal/AddActivityModal'

const showModal = ref(false)
const emit = defineEmits({ cancel: (_value) => true });

const localDB = [
    {
        id: 1,
        location: 'Nice',
        img: 'https://media-cdn.tripadvisor.com/media/photo-m/1280/21/c2/10/af/angelo-terra-d-italia.jpg',
        alt: '',
        title: "Angelo Terra d'Italia",
        content: 'Tre retters middag lorem ipsum dolor sit am et, consectetur adipiscing elit, sed do eius mod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.'
    },
    {
        id: 2,
        location: 'Nice',
        img: 'https://boscolocollection.com/nice/wp-content/uploads/2022/02/3H6A9997-v2.jpg',
        alt: '',
        title: "Angelo Kebab house",
        content: 'Tre retters middag lorem ipsum dolor sit am et, consectetur adipiscing elit, sed do eius mod tempor incididunt ut labore et dolore magna aliqua.'
    },
    {
        id: 3,
        location: 'Nice',
        img: 'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/21/c2/10/bf/angelo-terra-d-italia.jpg?w=2400&h=1600&s=1',
        alt: '',
        title: "Angelo Movie center",
        content: 'Tre retters middag lorem ipsum dolor sit am et, consectetur adipiscing elit, sed do eius mod.'
    },
]

const otherDB = [
    {
        id: 100,
        location: 'Nice',
        img: 'https://boscolocollection.com/nice/wp-content/uploads/2022/02/3H6A0206.jpg',
        alt: '',
        title: "Dinner",
        content: 'Tre retters middag'
    },
    {
        id: 101,
        location: 'Nice',
        img: 'https://www.cotemagazine.com/images/2022/07/27/angelo_nice_cocktails95.jpg',
        alt: '',
        title: "Drinks",
        content: 'adipiscing elit, sed do eius mod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.'
    },
    {
        id: 102,
        location: 'Nice',
        img: 'https://media-cdn.tripadvisor.com/media/photo-m/1280/23/f2/09/e5/angelo-terra-d-italia.jpg',
        alt: '',
        title: "Dessert",
        content: 'sed do eius mod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.'
    },
    {
        id: 103,
        location: 'Nice',
        img: 'https://media-cdn.tripadvisor.com/media/photo-m/1280/21/c2/10/af/angelo-terra-d-italia.jpg',
        alt: '',
        title: "Angelo Terra d'Italia",
        content: 'Tre retters middag lorem ipsum dolor sit am et, consectetur adipiscing elit, sed do eius mod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.'
    },
]

function cancel() {
    showModal.value = false
}

const addActivity = (activity) => {
    // Send result from activity to trip highlights component
    const cards = activity
    emit('activityCard', {cards})
    showModal.value = false
}

</script>
